import React from 'react';
import { Typography } from 'antd';
import classnames from 'classnames';
import { FAQQuestion } from '../../utils/faq';
import Button from '../../components/Button/Button';
import buttonStyles from '../../components/Button/Button.module.less';
import styles from './QuestionDetails.module.less';
import { useTranslation } from 'react-i18next';
import { reportDislikeAnswer, reportLikeAnswer } from '../../utils/reporter';

type QuestionDetailsProps = {
  question: FAQQuestion;
  onBackClick: () => void;
};

function QuestionDetails(props: QuestionDetailsProps) {
  const { question } = props;
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.questionDetails}>
        <Typography.Title level={2}>{question.question}</Typography.Title>
        <div className={styles.answerContainer}>
          <Typography.Text className={styles.answer}>{question.answer}</Typography.Text>
        </div>
      </div>
      <div className={styles.actionBar}>
        <div className={styles.feedbackContainer}>
          <div className={styles.feedbackQuestion}>
            <Typography.Text>{t('faq.isUseful')}</Typography.Text>
          </div>
          <div>
            <Button
              className={classnames([buttonStyles.button, styles.feedbackButton])}
              data-testid={'yesButton'}
              onClick={() => {
                reportLikeAnswer(question.question);
              }}
            >
              {t('general.yes')}
            </Button>
          </div>
          <div>
            <Button
              className={classnames([buttonStyles.button, styles.feedbackButton])}
              data-testid={'noButton'}
              onClick={() => {
                reportDislikeAnswer(question.question);
              }}
            >
              {t('general.no')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuestionDetails;
